import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { GET_PARKING_SPOTS_BASE_QUERY_KEY } from './get-parking-spots'
import { GET_RESIDENT_VEHICLES_BASE_QUERY_KEY } from './get-resident-vehicles'

interface UploadParkingCsvRequest {
  buildingId: number
  file: File
}

export interface UploadParkingCsvResponse {
  assigned: number
  created: number
  skipped: number
  skippedDuplicate: number
  unassigned: number
}

export const uploadParkingCsv = async (data: UploadParkingCsvRequest) => {
  const formData = new FormData()
  formData.append('buildingId', String(data.buildingId))
  formData.append('csv', data.file)

  const response = await authAPI.post<UploadParkingCsvResponse>('/parking/csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return response.data
}

export const useUploadParkingCsv = () => {
  return useMutation({
    mutationFn: uploadParkingCsv,
    onSuccess: async () => {
      await resetQueries([GET_PARKING_SPOTS_BASE_QUERY_KEY], [GET_RESIDENT_VEHICLES_BASE_QUERY_KEY])
    },
  })
}
